import type { ICourseReviewsDto, ICourseReviewsResponse } from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { states } from "@api/courses/reviews/states/api";
import type { ICourseResponse } from "@api/courses/types";
import { createPostApi } from "@api/util/createPostApi";
import { createDeleteApi } from "@api/util/createDeleteApi";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ICourseReviewsResponse, ICourseResponse>>,
  IPathBaseParam,
  IPaginationParams
>("courses.reviews");
const getApis = createGetApi<
  IApiResponse<ICourseReviewsResponse>,
  IPathByIdParam,
  object
>("courses.reviews");
const postApis = createPostApi<
  IApiResponse<ICourseReviewsResponse>,
  IPathBaseParam,
  ICourseReviewsDto
>("courses.reviews");
const deleteApis = createDeleteApi<
  IApiResponse<ICourseReviewsResponse>,
  IPathByIdParam
>("courses.reviews");

export const reviews = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...deleteApis,
  states,
};
